import type { Routes } from '@angular/router';
import { ReaderComponent } from './pages/reader/reader';
import { cipherKeyResolver } from './resolvers/cipher-key-resolver';
import { tokenResolver } from './resolvers/token-resolver';

export const routes: Routes = [
  {
    path: ':token/:cipherKey',
    component: ReaderComponent,
    resolve: {
      token: tokenResolver,
      cipherKey: cipherKeyResolver,
    },
  },
];
